import { Link } from "react-router-dom";
import { Box, MessageCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { api, formatPrice } from "../lib/api";

export default function ProductCard({ product, showStock = false }) {
    const [wa, setWa] = useState(null);
    useEffect(() => {
        api.get("/settings").then((r) => {
            const num = (r.data?.whatsapp || "").replace(/[^0-9]/g, "");
            if (num) setWa(num);
        }).catch(() => {});
    }, []);

    const img = product.images?.[0];
    const stock = product.stock || 0;

    const waLink = wa
        ? `https://wa.me/${wa}?text=${encodeURIComponent(`Hola, me interesa el producto: ${product.name}${product.sku ? ` (SKU: ${product.sku})` : ""}.`)}`
        : null;

    return (
        <div className="lz-card group relative" data-testid={`product-card-${product.id}`}>
            <Link to={`/producto/${product.id}`} className="block">
                <div className="aspect-square bg-[#f3f4f6] overflow-hidden border-b border-[var(--lz-navy)] relative">
                    {img ? (
                        <img
                            src={img}
                            alt={product.name}
                            loading="lazy"
                            className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                        />
                    ) : (
                        <div className="w-full h-full flex items-center justify-center text-[var(--lz-navy)]/30">
                            <Box className="w-16 h-16" />
                        </div>
                    )}
                    {product.featured && (
                        <span className="absolute top-2 left-2 lz-tag bg-[var(--lz-orange)] text-[var(--lz-navy)]">Destacado</span>
                    )}
                    {showStock && stock === 0 && (
                        <span className="absolute top-2 right-2 lz-tag bg-[var(--lz-navy)] text-white">Agotado</span>
                    )}
                </div>
                <div className="p-4">
                    {product.brand && (
                        <div className="text-[10px] font-bold uppercase tracking-[0.25em] text-[var(--lz-orange)] mb-1">{product.brand}</div>
                    )}
                    <h3 className="font-display font-bold uppercase text-base leading-tight line-clamp-2 min-h-[2.5em]">
                        {product.name}
                    </h3>
                    <div className="mt-3 flex items-end justify-between gap-2">
                        <div>
                            <div className="font-display text-2xl font-bold text-[var(--lz-navy)]">{formatPrice(product.price)}</div>
                            {showStock && (
                                <div className="text-[11px] uppercase tracking-wider text-[var(--lz-navy)]/60 font-mono">
                                    {stock > 0 ? `Stock: ${stock}` : "Sin stock"}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </Link>
            {waLink && (
                <a
                    href={waLink}
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => e.stopPropagation()}
                    className="absolute bottom-4 right-4 inline-flex items-center justify-center w-10 h-10 bg-[var(--lz-navy)] text-white hover:bg-[var(--lz-orange)] hover:text-[var(--lz-navy)]"
                    data-testid={`whatsapp-${product.id}`}
                    aria-label="Consultar por WhatsApp"
                    title="Consultar por WhatsApp"
                >
                    <MessageCircle className="w-5 h-5" />
                </a>
            )}
        </div>
    );
}
